var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListviewGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.043,
    height: 20.529,
    viewBox: "0 0 34.043 20.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #838383;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    className: "cls-1",
    d: "M9.725,34.245a1.7,1.7,0,0,1-1.264-.514,1.75,1.75,0,0,1-.5-1.274,1.7,1.7,0,0,1,.514-1.264,1.753,1.753,0,0,1,1.274-.5,1.7,1.7,0,0,1,1.264.514,1.75,1.75,0,0,1,.5,1.274A1.7,1.7,0,0,1,11,33.741,1.746,1.746,0,0,1,9.725,34.245Zm.053-8.519a1.7,1.7,0,0,1-1.264-.514,1.753,1.753,0,0,1-.5-1.274,1.7,1.7,0,0,1,.514-1.264,1.749,1.749,0,0,1,1.273-.5,1.7,1.7,0,0,1,1.264.514,1.746,1.746,0,0,1,.5,1.274,1.7,1.7,0,0,1-.514,1.263A1.75,1.75,0,0,1,9.778,25.726Zm0-8.455a1.7,1.7,0,0,1-1.264-.514,1.753,1.753,0,0,1-.5-1.274,1.7,1.7,0,0,1,.514-1.264,1.745,1.745,0,0,1,1.273-.5,1.7,1.7,0,0,1,1.264.514,1.746,1.746,0,0,1,.5,1.273,1.7,1.7,0,0,1-.514,1.264A1.75,1.75,0,0,1,9.778,17.271ZM14.5,34V31H42v3Zm0-8.5v-3H42v3Zm0-8.5V14H42v3Z",
    transform: "translate(-7.957 -13.716)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListviewGrey);
export default __webpack_public_path__ + "static/media/ListviewGrey.a64486d6bcfdacf91b30b25c3bbedd00.svg";
export { ForwardRef as ReactComponent };